export const glassToken = {
	borderRadius: 12,
	borderRadiusLG: 12,
	borderRadiusSM: 12,
	borderRadiusXS: 12,
	motionDurationSlow: '0.2s',
	motionDurationMid: '0.1s',
	motionDurationFast: '0.05s',
} as const;

export const getGlassComponents = (darkMode: boolean) => {
	const bg = darkMode ? 'rgba(30, 30, 30, 0.55)' : 'rgba(255, 255, 255, 0.45)';
	const bgInput = darkMode ? 'rgba(30, 30, 30, 0.4)' : 'rgba(255, 255, 255, 0.35)';
	const bgElevated = darkMode ? 'rgba(42, 42, 42, 0.75)' : 'rgba(255, 255, 255, 0.6)';

	return {
		Card: {
			colorBgContainer: bg,
			borderRadius: 12,
			borderRadiusLG: 12,
		},
		Input: {
			colorBgContainer: bgInput,
			borderRadius: 12,
			hoverBorderColor: darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.6)',
			activeBorderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.2)',
		},
		InputNumber: {
			colorBgContainer: bgInput,
			borderRadius: 12,
		},
		Select: {
			colorBgContainer: bgInput,
			colorBgElevated: bgElevated,
			borderRadius: 12,
		},
		DatePicker: {
			colorBgContainer: bgInput,
			colorBgElevated: bgElevated,
			borderRadius: 12,
		},
		Dropdown: {
			colorBgElevated: bgElevated,
			borderRadius: 12,
			borderRadiusLG: 12,
		},
		Modal: {
			colorBgElevated: bg,
			borderRadius: 12,
			borderRadiusLG: 12,
		},
		Popover: {
			colorBgElevated: bgElevated,
			borderRadius: 12,
			borderRadiusLG: 12,
		},
		Alert: {
			colorInfoBg: bgInput,
			colorSuccessBg: bgInput,
			colorWarningBg: bgInput,
			colorErrorBg: bgInput,
			borderRadius: 12,
		},
		ColorPicker: {
			colorBgElevated: bgElevated,
			borderRadius: 12,
		},
		Progress: {
			borderRadius: 12,
		},
		Segmented: {
			colorBgLayout: 'transparent',
			colorBgElevated: bgElevated,
			borderRadius: 12,
		},
		Switch: {
			borderRadius: 12,
		},
	};
};
